import { NJSpinner } from "@engie-group/fluid-design-system-react";

export const LoaderFallback = () => {
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background:
          "var(--nj-semantic-color-background-neutral-primary-default)",
      }}
    >
      <NJSpinner scale="lg" aria-label="" />
    </div>
  );
};
